import { ENDPOINTS, getApiUrl, Requests } from "@/common";
import {
  IDashboardOverview,
  IDashboardStats,
  IRecentActivity,
  IProgressChart,
  IRecommendation,
} from "@/common/types/dashboard";

export const dashboardService = {
  // Get dashboard overview
  getDashboardOverview: async (): Promise<IDashboardOverview> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_OVERVIEW));
    return response.data;
  },

  // Get dashboard statistics
  getDashboardStats: async (): Promise<IDashboardStats> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_STATS));
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (): Promise<IRecentActivity[]> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_RECENT_ACTIVITIES));
    return response.data;
  },

  // Get progress chart data
  getProgressChart: async (): Promise<IProgressChart> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_PROGRESS_CHART));
    return response.data;
  },

  // Get recommendations
  getRecommendations: async (): Promise<IRecommendation[]> => {
    const response = await Requests.get(getApiUrl(ENDPOINTS.GET_DASHBOARD_RECOMMENDATIONS));
    return response.data;
  },
};
